import React, { useEffect, useState } from "react";
import "./Contact.css";
import AOS from "aos";
import "aos/dist/aos.css";

const Contact = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission here
    console.log("Form submitted:", formData);
    alert("Thank you for contacting us! We will get back to you soon.");
    // Reset form
    setFormData({
      name: "",
      email: "",
      phone: "",
      subject: "",
      message: "",
    });
  };

  return (
    <div>
      {/* Hero Section */}
      <section
        className="contact-hero-section"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL + "/images/hero2.jpeg"})`,
        }}
      >
        <div className="overlay"></div>
        <div className="contact-hero-content" data-aos="fade-up">
          <h1>Contact Us</h1>
          <p>Get in touch with Riksons Inspection Services</p>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="contact-info-section" data-aos="fade-up">
        <div className="contact-intro">
          <h2>We'd Love to Hear From You</h2>
          <p>
            Have questions about our inspection services? Need a quote or want to discuss your project requirements? 
            Our team is here to help. Reach out to us and we'll respond promptly.
          </p>
        </div>

        <div className="contact-details">
          <div className="contact-card" data-aos="fade-up" data-aos-delay="100">
            <div className="contact-icon">
              <span>📍</span>
            </div>
            <h3>Our Location</h3>
            <p>Riksons Inspection Services</p>
            <p>Chennai, Tamil Nadu, India</p>
          </div>

          <div className="contact-card" data-aos="fade-up" data-aos-delay="200">
            <div className="contact-icon">
              <span>📞</span>
            </div>
            <h3>Phone</h3>
            <p>+91 XXXXX XXXXX</p>
            <p>Mon - Sat: 9:00 AM - 6:00 PM</p>
          </div>

          <div className="contact-card" data-aos="fade-up" data-aos-delay="300">
            <div className="contact-icon">
              <span>✉️</span>
            </div>
            <h3>Email</h3>
            <p>info@riksonsinspection.com</p>
            <p>support@riksonsinspection.com</p>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-form-section" data-aos="fade-up">
        <div className="form-container">
          <h2>Send Us a Message</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Enter your name"
                />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="Enter your email"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="phone">Phone Number</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Enter your phone number"
                />
              </div>
              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="Enter subject"
                />
              </div>
            </div>

            <div className="form-group">
              <label htmlFor="message">Message*</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                rows="6"
                placeholder="Tell us about your project or inquiry..."
              ></textarea>
            </div>

            <button type="submit" className="submit-btn">
              Send Message
            </button>
          </form>
        </div>
      </section>

      {/* Map Section (Optional) */}   
    </div>
  );
};

export default Contact;


